let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1gkvI")).then(() => parcelRequire('9MOi4'));